/**
 * Signup
 * Handles initial sign-up page by collecting data entered then forwarding to he defined landing page
 * 
 * Config Options
 * -- landingPage : Page that the user is sent to after data is collected
 */
define('components/signup',[
    'jquery',
    'logging',
    'application',
    'storage',
    'components/custom-propagation',
    'components/captcha'
], function($, logging, app, storage, customPropagation, captcha) {
    'use strict';
    
    var _ModuleName = "Initial Signup Page";
    var _submitLock = false;

    var _data = {
        landingPage: "",
        useV2Process: false,
        optOutCheck: {
            enabled: false,
            listId: 0,
            redirectUrl: ""
        }
    };

    var _fieldNames = {
        email: [
            'email',
            'email_address',
            'emailAddress'
        ],
        firstName: [
            'first',
            'first_name',
            'firstName'
        ],
        lastName: [
            'last',
            'last_name',
            'lastName'
        ],
        zip: [
            'zipcode',
            'zip',
            'zip_code',
            'postal_code'
        ],
        phone: [
            'phone',
            'phone_number',
            'phoneNumber',
            'mobile',
            'mobile_phone',
            'mobilePhone'
        ]
    }

    var init = function(config) {
        logging.debug("Initializing SignUp Component", _ModuleName);

        if(config && config.landingPage) {
            _data.landingPage = config.landingPage;
        }

        if (config && config.optOutCheck) {
            _data.optOutCheck = config.optOutCheck;
            _data.optOutCheck.enabled = _data.optOutCheck.listId && _data.optOutCheck.redirectUrl;
        }

        if(app.getProcessVersionNumber() == '2.0') {
            _data.useV2Process = true;
        }
    }

    var run = function() {
        logging.debug("Running SignUp Component", _ModuleName);
        
        var $form = $('form');
        
        logging.debug("Verifying form handle", _ModuleName);
        if ($form.length) {
            // Make sure we're only working with the first form
            if ($form.length > 1) {
                $form = $($form[0]);
            }

            // Store the tracking data
            var tracker = _getFieldValue($form, "track1");
            logging.debug("Storing Tracker: " + tracker, _ModuleName);
            storage.setSessionStorage("pttracker-track1", tracker);
            
            logging.debug("Disabling Default Form Submit", _ModuleName);
            // remove the default form actions, and set up our own.
            $form.unbind();
            $form.submit(function (event) {
                event.preventDefault();
                return false;
            });
        
            logging.debug("Storing Method and Action", _ModuleName);
            // hijack the form post so we can do it for them, and then forward them
            // along to the next page on their offer path.
            var method = $form.attr('method'),
                action = $form.attr('action');
            
            logging.debug("Method: " + method, _ModuleName);
            logging.debug("Action: " + action, _ModuleName);

            logging.debug("Removing Method and Action from Form");
            $form.removeAttr('method').removeAttr('action');
            // huge hack to avoid unbounce error messages in old versions of ie.
            window.alert = function (m) { };
        
            // slightly redefine the form keypress event that unbounce lays on the form. we want
            // the event to bubble up so our handler ultimately catches the event.
            if (window.lp && window.lp.jQuery) {
                // also unbind the submit button 
                window.lp.jQuery('.lp-pom-button').unbind();

                window.lp.jQuery($form).unbind('keypress').keypress(function (e) {
                    if (e.which === 13) {
                        var type = e.target && e.target.nodeName ? e.target.nodeName.toLowerCase() : '';
                        if (type !== 'textarea') {
                            window.lp.jQuery($form).valid();
                        }
                    }
                });
            }
        
            logging.debug("Updating Click Function of Button", _ModuleName);
            var $submit = $('.lp-pom-button');
            if($submit != null && $submit.length> 0) {
                $submit.click(function (e) {
                    e.preventDefault();

                    console.debug('form submit clicked');

                    // if we are using captcha
                    if (captcha.captchaIsEnabled()) {
                        console.debug('Captcha enabled');

                        // if captcha not yet validated
                        if (!captcha.captchaIsValidated()) {
                            console.debug('Captcha not yet validated, queueing handler for submit click, and initiating captcha validation');

                            // register callback
                            captcha.registerOnValidationFn(function() { _handleSubmitClick($form, action, method); });

                            // initiate captch validation
                            captcha.validateCaptcha();
                        } else {
                            console.debug('Captcha already validated, handling submit click');

                            // otherwise, go ahead and handle
                            _handleSubmitClick($form, action, method);
                        }
                    } else {
                        console.debug('Captcha not enabled, handling submit click');

                        // otherwise, go ahead and handle
                        _handleSubmitClick($form, action, method);
                    }
                });
            } else {
                logging.error("Couldn't find submit button to update", _ModuleName);
            }

            // Show Button if it is hidden
            var styles = $submit.attr('style');
            $submit.attr('style', styles + ';display:inline-block !important;');
        }
    }

    var _handleSubmitClick = function($form, action, method) {
        console.log('submit button clicked');

        logging.debug("Button was clicked, handling", _ModuleName);
        // If there's already a lock, bail
        if (_submitLock) {
            console.warn('submit button was already clicked, please hang tight');
            logging.warn("Button has already been clicked, please sit tight", _ModuleName);
            return;
        }

        // Get lock
        _submitLock = true;

        // this is to force the form to re-validate and to make sure we don't
        // just go ahead and post if the form has errors. unbounce implements all
        // of their validation with a different jQuery context, so we need to
        // make sure to use their context, as the validator doesn't  exist on our $ context.
        try {
            if (window.lp && window.lp.jQuery) {
                // Grab form element using Unbounces own jQuery instance
                var $ubForm = window.lp.jQuery('form');
                // Run validation
                var validation = $ubForm.validate();
                // Check if form is valid
                if ($ubForm.length > 0 && !$ubForm.valid()) {
                    console.error("Form validation failed, form not marked valid.");
                    // Trigger native form validation messages
                    $ubForm[0].reportValidity();
                    _submitLock = false;
                    return false;
                }
            } else if ($form && $form.length) {
                if ($form[0].checkValidity() === false) {
                    console.error("Form validation failed (native), form not marked valid.");
                    // Trigger native form validation messages
                    $form[0].reportValidity();
                    _submitLock = false;
                    return false;
                }
            }

            console.log('form validation passed');
        }
        catch (ex) {
            console.error("Something went wrong checking validation.", _ModuleName);
            _submitLock = false;
            return false;
        }

        try {
            var $confirmAction = $('input[name=openpageonconfirm]', $form);
            if ($confirmAction.length) {
                var url = $confirmAction.attr('value');
                if (typeof url !== undefined) {
                    window.open(url);
                }
            }
        }
        catch (ex) { }

        if(action) {
            action += (action.indexOf('?') < 0 ? '?' : '&') + 'lp-form-submit-method=ajax'
        }
        logging.debug("Submitting Form Data Ourselves to " + action, _ModuleName);

        if (_data.optOutCheck.enabled) {
            _doOptOutCheck(
                // email address
                _getFieldValue($form, _fieldNames.email), 
                // configured opt out list id
                _data.optOutCheck.listId, 
                // function to run if user not opted out
                function() { 
                    // submit form
                    _doFormSubmit($form, action, method); 
                }
            );
        } else {
            // submit form
            _doFormSubmit($form, action, method);
        }

        return false;
    }

    var _doFormSubmit = function($form, action, method) {
        $.ajax({
            url: action,
            type: method,
            data: $form.serialize(),
            error: function (xhr, status, error) { try { logging.error('error: ' + error, _ModuleName);  } catch (ex) { } },
            success: function (data, status, xhr) { try { logging.debug('success!', _ModuleName); } catch (ex) { } },
            complete: function (xhr, status) 
            {
                var $localForm = $form;
                var destination = '';
                if (customPropagation.enabled()) {
                    console.log("Custom Propogation is Enabled. Attempting to get field data information.");
                    var fieldName = customPropagation.getTargetFieldName();
                    if (fieldName) {
                        console.log("Custom Propogation field found [" + fieldName + "]");
                        var value = _getFieldValue($localForm, fieldName);
                        console.log("Custom Propogation field value is " + value);

                        destination = customPropagation.getDestination(value);

                        console.log("Custom Propogation Destination: " + destination);
                    }
                } else {
                    console.log("Custom Propogation not Enabled. Skipping.");
                }

                if(_data.useV2Process) {
                    console.log("Submission was successful");
                    console.log("Submitting Lead Information via Application v2 Processes");

                    var firstName = _getFieldValue($form, _fieldNames.firstName);
                    var lastName = _getFieldValue($form, _fieldNames.lastName);
                    var email = _getFieldValue($form, _fieldNames.email);
                    var zip = _getFieldValue($form, _fieldNames.zip);
                    var phone = _getFieldValue($form, _fieldNames.phone);

                    app.submitLead(firstName, lastName, email, zip, phone, function() {
                        console.log("Notify parent of impression");
                        app.submitImpression($form, (function() {
                            console.log("Notifying parent we're done here");
                                if (destination) { console.log("Also notifying parent of custom destination: " + destination); }
                                app.notifyParentComplete(destination);
                        }), true);   
                    });

                } else {
                    console.debug("Process using V1 so no extra processing needed. Using legacy propogation", _ModuleName);

                    if (destination) {
                        window.location.href = destination;
                    } else if(_data.landingPage) {
                        var url = _data.landingPage;
                        window.location.href = url;
                    } else {
                        try {
                            var url = window.module.lp.form.data.confirmData;
                        } catch(e) { }
                    }

                    if(url) {
                        window.location.href = url + window.location.search;
                    } else {
                        logging.error("No landing page defined, and unable to find it in unbounce data", _ModuleName);
                    }
                }
            }
        });
    }

    var _doOptOutCheck = function(email, optOutListId, doSubmitFn) {
        console.debug('opt out check requested for ' + email);
        app.checkOptOutByListId(email, optOutListId, function(optOut) {
            console.debug('Opt Out response returned: ' + (optOut ? 'yes' : 'no'));
            // if user is opted-out, redirect
            if (optOut) {
                _doOptOutRedirect(email);
            } 
            
            // otherwise, run submit function if provided
            else if (typeof doSubmitFn === 'function') {
                doSubmitFn();
            }
        });
    }

    var _doOptOutRedirect = function(email) {
        var redirectUrl = _data.optOutCheck.redirectUrl;
        
        redirectUrl = redirectUrl + (redirectUrl.indexOf('?') < 0 ? '?' : '&') + 'email=' + email;
        redirectUrl = redirectUrl + '&rsid=' + app.getRSID();
        
        // loop through all tracked parameters, and if value is present, add to redirect url
        var keys = app.getTrackedParameterKeys();
        keys.forEach(function(key) {
            var paramVal = app.getTrackedParameterValue(key);
            if (paramVal) {
                redirectUrl = redirectUrl + '&' + key + '=' + paramVal;
            }
        });
        
        window.top.location.href = redirectUrl;

        console.debug('Redirecting to ' + redirectUrl);
    }

    
    var _getFieldValue = function($form, name) {
        if(typeof name == 'string') {
            var field = $form.find("input[name='" + name + "']");
            if (field && field.length > 0) {
                // account for radio buttons and checkboxes by filtering for actual selection
                if (field[0].type === "radio" || field[0].type === "checkbox") {
                    field = $form.find("input[name='" + name + "']:checked");
                }

                return field.length ? field[0].value : '';
            }
        }

        if(Array.isArray(name)) {
            for(var i = 0; i < name.length; i++) {
                var field = $form.find("input[name='" + name[i] + "']");
                if(field.length) {
                    return field[0].value;
                }
            }
        }

        return '';
    }

    return {
        init: init,
        run: run
    }
});
